import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, BrandsDocument, BrandDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { Page } from '@components/organisms'
import { BrandTemplate } from '@components/templates'

const BrandDetail = ({ pagina, brand }) => <BrandTemplate pagina={pagina} brand={brand} />

export const getStaticPaths = NextWrapper.getStaticPaths(async ({ locales }) => {
  let paths = []

  // for (const locale of locales) {
  //   if (locale === 'default') continue

  //   const client = initializeApollo(locale)

  //   const {
  //     data: { brands },
  //   } = await client.query({
  //     query: BrandsDocument,
  //   })

  //   brands?.forEach((x) => paths.push({ params: { slug_brand: x.slug }, locale: locale }))
  // }

  return {
    paths: paths,
    fallback: 'blocking',
  }
}, '/collezioni/[slug]')

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { slug_brand }, locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { brand },
    } = await client.query({
      query: BrandDocument,
      variables: { slug: slug_brand },
    })

    if (!brand) {
      return {
        notFound: true,
      }
    }

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: {
        contentTypeId: brand.model,
        objectId: brand.pk,
        chiave: 'brand-detail',
        preview,
      },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina, brand },
      revalidate: 60 * 20 * 24,
    }
  },
  '/collezioni/[slug_brand]'
)

export default BrandDetail
